import Vue from 'vue'
import Router from 'vue-router'
import AppSidebar from './components/AppNavbar.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        landing: () => import('./views/app/Home.vue')
      }
    },
    {
      path: '/home-article',
      name: 'homeArticle',
      components: {
        article: () => import('./views/app/HomeArticle.vue')
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      components: {
        policy: () => import('./views/app/PrivacyPolicy.vue')
      }
    },
    {
      path: '/app/login',
      name: 'appLogin',
      components: {
        login: () => import('./views/app/Login.vue')
      } 
    },
    {
      path: '/app/dashboard',
      name: 'appDashboard',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/Dashboard.vue')
      } 
    },
    // App Master Route
    {
      path: '/app/vendor',
      name: 'appVendor',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/Vendor.vue')
      } 
    },
    {
      path: '/app/vendor/detail',
      name: 'appVendorDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/VendorDetail.vue')
      } 
    },
    {
      path: '/app/brand',
      name: 'appBrand',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/Brand.vue')
      } 
    },
    {
      path: '/app/brand/detail',
      name: 'appBrandDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/BrandDetail.vue')
      } 
    },
    {
      path: '/app/product',
      name: 'appProduct',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/Product.vue')
      }
    },
    {
      path: '/app/product/detail',
      name: 'appProductDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ProductDetail.vue')
      } 
    },
    {
      path: '/app/product-price',
      name: 'appProductPrice',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ProductPrice.vue')
      }
    },
    {
      path: '/app/product-price/detail',
      name: 'appProductPriceDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ProductPriceDetail.vue')
      }
    },
    {
      path: '/app/product-type',
      name: 'appProductType',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ProductType.vue')
      }
    },
    {
      path: '/app/product-type/detail',
      name: 'appProductTypeDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ProductTypeDetail.vue')
      }
    },
    {
      path: '/app/vehicle',
      name: 'appVehicle',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/Vehicle.vue')
      }
    },
    {
      path: '/app/vehicle/detail',
      name: 'appVehicleDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/VehicleDetail.vue')
      }
    },
    {
      path: '/app/service',
      name: 'appService',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/Service.vue')
      }
    },
    {
      path: '/app/service/detail',
      name: 'appServiceDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ServiceDetail.vue')
      }
    },
    {
      path: '/app/product-price',
      name: 'appProductPrice',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ProductPrice.vue')
      }
    },
    {
      path: '/app/product-price-detail',
      name: 'appProductPriceDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/ProductPriceDetail.vue')
      }
    },
    {
      path: '/app/vehicle-brand',
      name: 'appVehicleBrand',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/VehicleBrand.vue')
      } 
    },
    {
      path: '/app/vehicle-brand/detail',
      name: 'appVehicleBrandDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/master/VehicleBrandDetail.vue')
      } 
    },
    // App Transaction Route
    {
      path: '/app/purchase-order',
      name: 'appPO',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/PurchaseOrder.vue')
      } 
    },
    {
      path: '/app/purchase-order/detail',
      name: 'appPODetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/PurchaseOrderDetail.vue')
      }
    }, 
    {
      path: '/app/purchase-invoice',
      name: 'appPI',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/PurchaseInvoice.vue')
      } 
    },
    {
      path: '/app/purchase-invoice/detail',
      name: 'appPIDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/PurchaseInvoiceDetail.vue')
      }
    },
    {
      path: '/app/purchase-return',
      name: 'appPurchaseReturn',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/PurchaseReturn.vue')
      } 
    },
    {
      path: '/app/purchase-return/detail',
      name: 'appPurchaseReturnDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/PurchaseReturnDetail.vue')
      }
    },
    {
      path: '/app/sales-invoice',
      name: 'appSI',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/SalesInvoice.vue')
      } 
    },
    {
      path: '/app/sales-invoice/detail',
      name: 'appSIDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/SalesInvoiceDetail.vue')
      }
    },
    {
      path: '/app/product-receive',
      name: 'appProductReceive',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/ProductReceive.vue')
      } 
    },
    {
      path: '/app/product-receive/detail',
      name: 'appProductReceiveDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/transaction/ProductReceiveDetail.vue')
      }
    },
    // Invoicing section
    {
      path: '/app/report/preview/sales-invoice',
      name: 'appRptSalesInvoicePrint',
      components: {
        report: () => import('./views/app/report/RptSalesInvoicePrint.vue')
      }
    },
    {
      path: '/app/purchase-invoice-print',
      name: 'appPurchaseInvoicePrint',
      components: {
        report: () => import('./views/app/transaction/PurchaseInvoicePrint.vue')
      }
    },
    {
      path: '/app/purchase-order-print',
      name: 'appPurchaseOrderPrint',
      components: {
        report: () => import('./views/app/transaction/PurchaseOrderPrint.vue')
      }
    },
    {
      path: '/app/purchase-return-print',
      name: 'appPurchaseReturnPrint',
      components: {
        report: () => import('./views/app/transaction/PurchaseReturnPrint.vue')
      }
    },
    // Reporting section
    {
      path: '/app/report/purchase-order',
      name: 'appRptPurchaseOrder',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/report/RptPurchaseOrder.vue')
      }
    },
    {
      path: '/app/report/preview/purchase-order',
      name: 'appRptPurchaseOrderPrint',
      components: {
        report: () => import('./views/app/report/RptPurchaseOrderPrint.vue')
      }
    },
    {
      path: '/app/report/outstanding-purchase-order',
      name: 'appRptOutstandingPO',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/report/RptOutstandingPO.vue')
      }
    },
    {
      path: '/app/report/preview/outstanding-purchase-order',
      name: 'appRptOutstandingPOPrint',
      components: {
        report: () => import('./views/app/report/RptOutstandingPOPrint.vue')
      }
    },
    {
      path: '/app/report/sales',
      name: 'appRptSales',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/report/RptSales.vue')
      }
    },
    {
      path: '/app/report/preview/sales',
      name: 'appRptSalesPrint',
      components: {
        report: () => import('./views/app/report/RptSalesPrint.vue')
      }
    },
    {
      path: '/app/report/profit',
      name: 'appRptProfit',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/report/RptProfit.vue')
      }
    },
    {
      path: '/app/report/preview/profit',
      name: 'appRptProfitPrint',
      components: {
        report: () => import('./views/app/report/RptProfitPrint.vue')
      }
    },
    {
      path: '/app/report/inventory-valuation',
      name: 'appRptInventoryValuation',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/report/RptInventoryValuation.vue')
      }
    },
    {
      path: '/app/report/preview/inventory-valuation',
      name: 'appRptInventoryValuationPrint',
      components: {
        report: () => import('./views/app/report/RptInventoryValuationPrint.vue')
      }
    },
    {
      path: '/app/report/inventory-mutation',
      name: 'appRptInventoryMutation',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/report/RptInventoryMutation.vue')
      }
    },
    {
      path: '/app/report/preview/inventory-mutation',
      name: 'appRptInventoryMutationPrint',
      components: {
        report: () => import('./views/app/report/RptInventoryMutationPrint.vue')
      }
    },
    {
      path: '/app/report/purchase-invoice',
      name: 'appRptPurchaseInvoice',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/report/RptPurchaseInvoice.vue')
      }
    },
    {
      path: '/app/report/preview/purchase-invoice',
      name: 'appRptPurchaseInvoicePrint',
      components: {
        report: () => import('./views/app/report/RptPurchaseInvoicePrint.vue')
      }
    },
    // Utility section
    {
      path: '/app/article',
      name: 'appArticle',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/Article.vue')
      }
    },
    {
      path: '/app/article/detail',
      name: 'appArticleDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/ArticleDetail.vue')
      }
    },
    {
      path: '/app/promo',
      name: 'appPromotion',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/Promotion.vue')
      }
    },
    {
      path: '/app/promo/detail',
      name: 'appPromotionDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/PromotionDetail.vue')
      }
    },
    {
      path: '/app/member',
      name: 'appMember',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/Member.vue')
      }
    },
    {
      path: '/app/member/detail',
      name: 'appMemberDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/MemberDetail.vue')
      }
    },
    {
      path: '/app/user',
      name: 'appUser',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/User.vue')
      }
    },
    {
      path: '/app/user/detail',
      name: 'appUserDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/utility/UserDetail.vue')
      }
    },
    {
      path: '/app/product-apps',
      name: 'appProductApps',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/ProductApps.vue')
      }
    },
    {
      path: '/app/product-apps-detail',
      name: 'appProductAppsDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/ProductAppsDetail.vue')
      }
    },
    {
      path: '/app/service-apps',
      name: 'appServiceApps',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/ServiceApps.vue')
      }
    },
    {
      path: '/app/service-apps-detail',
      name: 'appServiceAppsDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/ServiceAppsDetail.vue')
      }
    },
    {
      path: '/app/validate-user',
      name: 'appValidateUser',
      components: {
        validate: () => import('./views/app/Validate.vue')
      }
    },
    {
      path: '/app/service-order',
      name: 'appServiceOrder',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/ServiceOrder.vue')
      }
    },
    {
      path: '/app/service-order-detail',
      name: 'appServiceOrderDetail',
      components: {
        sidebar: AppSidebar,
        content: () => import('./views/app/ServiceOrderDetail.vue')
      }
    }
  ]
})
